import { useState, useEffect } from 'react';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import { Singleton } from '../../../../core/services/Singleton';
import usePaginator from '../../../theme/Component/usePaginator';
import useModal, { MODAL_LG } from '../../../theme/Component/hooks/useModal';
import { Modal } from '../../../theme/Component/Modal';
import { BasicTable } from '../../../theme/Component/BasicTable';
import { _BodyComponent, _HealthAttentionCause, _HealthAttentionGateEntry, _HealthAttentionModality, _HealthAttentionService, _HealthAttentionSite, _HealthTechnologyType, _MedicalDevice, _TriageType } from '../../../../core/services/dataBean/EntityCatalogVdos';
import { BasicButton } from '../../../theme/Component/BasicButton';
import { ComponentTypeConstantsSelect } from './ComponentTypeConstantsSelect';


interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
    render?: string;
}

export const BodyComponentEditor = ({ idSelector, onChange, label, returnType = "ID", render }: Props) => {

    const { instance, lista, setLista } = useDataBean(_BodyComponent)
    const [id, setID] = useState(null);
    const [type, setType] = useState<any>(null)
    const single = Singleton.getInstance();
    const paginador = usePaginator();
    const [regexStr, setregexStr] = useState<any>(null)
    const modal = useModal("Tejidos/Órganos/Fluidos", MODAL_LG);

    useEffect(() => {
        setID(idSelector)
    }, [idSelector])

    useEffect(() => {
        getLista();
    }, [])

    const setValue = (e: string) => {
        const selectedId = parseInt(e);
        setID(selectedId);
        if (onChange) {
            const selectedItem = lista.find(
                (item) => item?.DataBeanProperties?.IDBodyComponent == e
            );
            if (selectedItem) {
                onChange(returnType === "Object" ? selectedItem?.DataBeanProperties : selectedId);
            } else {
                onChange(returnType === "Object" ? {} : null);
            }
        }
    };


   useEffect(() => {
        getLista();
    }, [paginador.page])

    const getLista = () => {

        instance.getBodyComponentCatalog(type,regexStr, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (15));
                    paginador.setRegiPerPage(15)
                    setLista(resp.List)
                }
            }
        )

    }
    const head = [
        { title: 'ID', property: 'IDBodyComponent', visible: true },
        { title: 'Código', property: 'Code', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Tipo', property: 'TypeName', visible: true },
        { title: 'Fecha', property: 'Since', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
    ]
    const abrirModal = () => {
        modal.open();
    }


    return (
        <>
            <label>{label ?? "Tejidos/Órganos/Fluidos"}</label>
            <span className='form-control cursor ifmodal' onClick={abrirModal}>{render ?? ''}</span>
            <Modal modal={modal.modal} updateModal={modal.setModal}>
                <div className="row">
                    <div className="col-md-6">
                            <ComponentTypeConstantsSelect idSelector={type} onChange={(e) => { setType(e) }}/>
                    </div>
                    <div className="col-md-6">
                        <label>Búsqueda por Texto</label>
                        <input type="text" className="form-control" value={regexStr} onChange={(e) => { setregexStr(e.target.value) }} />
                    </div>
                    <div className="col-md-6 mt-4 p-2">
                        <BasicButton icon="ri-align-justify" eventClick={getLista}>Buscar</BasicButton>
                    </div>
                </div>
                <BasicTable head={head} body={lista} rowSet={(e) => { setValue(e.IDBodyComponent); modal.close(); }} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
            </Modal>
        </>
    )
}